import React from 'react';
import { TouchableWithoutFeedback, View, } from 'react-native';
import { Avatar } from 'design-system/avatar/Avatar';
import { rem } from 'design-system/values';
import { CircleBadge } from 'design-system/Badge';
import { IconCamera } from 'design-system/icons';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
export const EditableAvatar = ({ size = 58, onPress, ...props }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const containerStyle = [
        { width: rem(size), height: rem(size) },
        styles.container,
    ];
    return (<TouchableWithoutFeedback onPress={onPress} {...props}>
      <View style={containerStyle}>
        <Avatar {...props} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} size={size - 4} large/>
        <CircleBadge backgroundColor={colors.elements.brand} offset={2} borderColor={colors.borders.iconStroke}>
          <IconCamera />
        </CircleBadge>
      </View>
    </TouchableWithoutFeedback>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 50,
        backgroundColor: colors.borders.logoStroke,
    },
}));
